import { useEffect } from "react";
import type { KioskLanguage } from "../types";

export function useGoogleTranslate(languages: KioskLanguage[]): void {
  useEffect(() => {
    const extra = (languages || []).filter(
      (l) => l.code && l.code.toLowerCase() !== "en"
    );
    if (extra.length === 0) return;
    if (typeof window === "undefined") return;
    if (
      (window as unknown as { __mkTranslateInit?: boolean }).__mkTranslateInit
    )
      return;
    (window as unknown as { __mkTranslateInit: boolean }).__mkTranslateInit =
      true;

    if (!document.getElementById("google_translate_element")) {
      const div = document.createElement("div");
      div.id = "google_translate_element";
      div.style.position = "absolute";
      div.style.left = "-9999px";
      div.style.top = "0";
      document.body.appendChild(div);
    }

    const includedLanguages = ["en", ...extra.map((l) => l.code)].join(",");
    (
      window as unknown as { googleTranslateElementInit: () => void }
    ).googleTranslateElementInit = () => {
      const g = (
        window as unknown as {
          google?: {
            translate?: {
              TranslateElement: new (opts: object, el: string) => void & {
                InlineLayout?: { SIMPLE: number };
              };
            };
          };
        }
      ).google;
      if (!g?.translate?.TranslateElement) return;
      new g.translate.TranslateElement(
        { pageLanguage: "en", includedLanguages, autoDisplay: false },
        "google_translate_element"
      );
    };

    if (!document.querySelector('script[data-mk-translate="1"]')) {
      const s = document.createElement("script");
      s.src =
        "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      s.async = true;
      s.dataset.mkTranslate = "1";
      document.head.appendChild(s);
    }
  }, [languages]);
}
